module.exports = __webpack_public_path__ + "static/media/barber-back-580.8631be8f.jpg";